(function () {
    window.KocotAnimations = window.KocotAnimations || {};

    window.KocotAnimations.initRealizationGalleryPopup = function () {
        var galleries = document.querySelectorAll('.realization-page-gallery');

        galleries.forEach(function (gallery) {
            if (gallery.dataset.galleryPopupInitialized === 'true') {
                return;
            }

            var popup = gallery.parentElement ? gallery.parentElement.querySelector('.realization-page-gallery-popup') : null;
            var popupImage = popup ? popup.querySelector('[data-gallery-popup-image]') : null;
            var popupTitle = popup ? popup.querySelector('[data-gallery-popup-title]') : null;
            var closeButton = popup ? popup.querySelector('[data-gallery-popup-close]') : null;
            var prevButton = popup ? popup.querySelector('[data-gallery-popup-prev]') : null;
            var nextButton = popup ? popup.querySelector('[data-gallery-popup-next]') : null;
            var items = Array.from(gallery.querySelectorAll('.realization-page-gallery-item'));
            var currentIndex = 0;

            if (!popup || !popupImage || !items.length) {
                return;
            }

            gallery.dataset.galleryPopupInitialized = 'true';

            function getItemTitle(item, image) {
                return image.getAttribute('alt') || item.dataset.galleryTitle || image.getAttribute('title') || '';
            }

            function renderTitle(title) {
                var currentTitle = popupTitle ? popupTitle.querySelector('.realization-page-gallery-popup-content-title-text.is-active') : null;

                if (!popupTitle) {
                    return;
                }

                if (currentTitle) {
                    currentTitle.classList.remove('is-active');
                    currentTitle.classList.add('is-leaving');

                    window.setTimeout(function () {
                        currentTitle.remove();
                    }, 900);
                }

                if (!title) {
                    return;
                }

                var nextTitle = document.createElement('span');

                nextTitle.className = 'realization-page-gallery-popup-content-title-text is-entering';
                nextTitle.textContent = title;
                popupTitle.appendChild(nextTitle);

                window.requestAnimationFrame(function () {
                    nextTitle.classList.remove('is-entering');
                    nextTitle.classList.add('is-active');
                });
            }

            function render(index) {
                var item = items[index];
                var image = item ? item.querySelector('img') : null;

                if (!image) {
                    return;
                }

                currentIndex = index;
                popupImage.src = item.dataset.galleryPopupSrc || image.currentSrc || image.src;
                popupImage.alt = image.getAttribute('alt') || '';
                popupImage.classList.remove('is-changing');
                void popupImage.offsetWidth;
                popupImage.classList.add('is-changing');

                if (popupTitle) {
                    renderTitle(getItemTitle(item, image));
                }
            }

            function open(index) {
                render(index);
                popup.hidden = false;
                popup.setAttribute('aria-hidden', 'false');
                document.documentElement.classList.add('is-gallery-popup-open');

                if (closeButton) {
                    closeButton.focus();
                }
            }

            function close() {
                popup.hidden = true;
                popup.setAttribute('aria-hidden', 'true');
                document.documentElement.classList.remove('is-gallery-popup-open');
                popupImage.removeAttribute('src');

                if (popupTitle) {
                    popupTitle.innerHTML = '';
                }
            }

            function showPrev() {
                render((currentIndex - 1 + items.length) % items.length);
            }

            function showNext() {
                render((currentIndex + 1) % items.length);
            }

            items.forEach(function (item, index) {
                item.setAttribute('tabindex', '0');
                item.setAttribute('role', 'button');

                item.addEventListener('click', function () {
                    open(index);
                });

                item.addEventListener('keydown', function (event) {
                    if (event.key !== 'Enter' && event.key !== ' ') {
                        return;
                    }

                    event.preventDefault();
                    open(index);
                });
            });

            if (closeButton) {
                closeButton.addEventListener('click', close);
            }

            if (prevButton) {
                prevButton.addEventListener('click', showPrev);
            }

            if (nextButton) {
                nextButton.addEventListener('click', showNext);
            }

            document.addEventListener('keydown', function (event) {
                if (popup.hidden) {
                    return;
                }

                if (event.key === 'Escape') {
                    close();
                }

                if (event.key === 'ArrowLeft') {
                    showPrev();
                }

                if (event.key === 'ArrowRight') {
                    showNext();
                }
            });
        });
    };
})();
